import type { LucideIcon } from 'lucide-react';
import { Boxes, ChartColumn, FlaskConical, IdCard, Wrench } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type NamedModule = { readonly code: string; readonly name: string };

const ICONS: Record<string, LucideIcon> = {
  finance: ChartColumn,
  'clinical-study': FlaskConical,
  'identity-documents': IdCard,
  tools: Wrench,
};

/** A module's icon, the same one the rail gives it; a generic one for a module the console does not know. */
export function moduleIcon(code: string): LucideIcon {
  return ICONS[code] ?? Boxes;
}

/** A module's plain name and what it is for, by its code; the catalog's name when the console has none. */
export function useModuleText() {
  const { t, i18n } = useTranslation('administration');
  const name = useCallback(
    (module: NamedModule) => {
      const key = `administration:modules.${module.code}`;
      return i18n.exists(key) ? t(key as never) : module.name;
    },
    [t, i18n],
  );
  const description = useCallback(
    (module: NamedModule) => {
      const key = `administration:moduleSection.descriptions.${module.code}`;
      return i18n.exists(key) ? t(key as never) : null;
    },
    [t, i18n],
  );
  return { name, description };
}
